import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useState } from "react"
import { useSelector } from "react-redux"

import withActions from "areas/product/hoc/with-actions"
import SizeOptions from "areas/product/jewlr/wizard-options/size-options"
import { ButtonWrapper } from "components/HalfModal/hm-styled-components"
import Modal, { closeModal } from "components/modal"
import Button from "components/ui/button"
import { jewlr_t, retry } from "helpers/application"

const SizeChart = loadable(() => retry(() => import("./size-chart")))

const RingSizeHalfModal = ({
  addToCart,
  choices,
  forcePanelIndex,
  wizardData,
}) => {
  const title = `${productType === "RING" ? "Ring" : ""} Size`
  const [loading, setLoading] = useState(false)
  const [contentIndex, setContentIndex] = useState(0)

  const availableHolidayDelivery = useSelector(
    (state) =>
      state.wizard.shippin?.main?.available_holiday_delivery &&
      state.wizard.inventory &&
      !state.wizard.inventory.non_inventory_available_holiday_delivery
  )
  const productType = useSelector(
    (state) => state.wizard.description.product_type
  )

  if (!wizardData || !wizardData.sz) {
    return ""
  }

  const modalTitle =
    contentIndex === 1 ? `${title} Guide` : `Choose Your ${title}`

  return (
    <Modal
      contentIndex={contentIndex}
      height="fit-content"
      label={modalTitle}
      onBack={() => setContentIndex(contentIndex - 1)}
      onClose={() => {
        forcePanelIndex("sz")
        closeModal()
        setTimeout(() => setContentIndex(0), 400)
      }}
      show="#ring-size"
      variant="squircle"
      width="640px"
      withBackButton
    >
      {contentIndex === 1 && <SizeChart />}
      {contentIndex === 0 && (
        <>
          <div>
            {!wizardData.sz.not_a_ring && (
              <div className="leading-20 text-center tracking-tight">
                <h3 className="text-16 mb-8 font-medium">
                  The average ring size for{" "}
                  {wizardData.sz.male ? "men" : "women"} is{" "}
                  {wizardData.sz.avg_size}
                </h3>
                <p className="text-neutral text-14 tablet:mb-0 mb-8 font-medium">
                  Unsure of the size? Please see our{" "}
                  <Button
                    className="text-14"
                    onClick={() => setContentIndex(contentIndex + 1)}
                    text
                    underline
                    variant="secondary"
                  >
                    Size Chart
                  </Button>
                </p>
                {availableHolidayDelivery && (
                  <p className="text-green-darker tablet:mb-0 mb-8 font-bold">
                    *Note: Sizes marked in green are available for{" "}
                    {sl.config.guaranteed_holiday} Delivery.
                  </p>
                )}
                {wizardData.sz.size_tip && (
                  <p className="text-neutral text-12 tablet:mb-24 tablet:mt-0 mb-32 mt-8 font-light">
                    {wizardData.sz.size_tip}
                  </p>
                )}
              </div>
            )}
            <SizeOptions
              modal
              opened
              pref={wizardData.sz.pref}
              sizePref={null}
            />
          </div>
          <ButtonWrapper>
            <Button
              data-cy="product-modal-sz-proceed-to-cart-btn"
              disabled={choices && choices.sz && choices.sz.value === ""}
              loading={loading}
              onClick={(e) => {
                setLoading(true)
                addToCart(e)
              }}
              variant="secondary"
            >
              Proceed to {jewlr_t("Cart")}
            </Button>
          </ButtonWrapper>
        </>
      )}
    </Modal>
  )
}

RingSizeHalfModal.propTypes = {
  addToCart: PropTypes.func,
  availableHolidayDelivery: PropTypes.bool,
  choices: PropTypes.object,
  forcePanelIndex: PropTypes.func,
  productType: PropTypes.string,
  wizardData: PropTypes.object,
}

export default withActions(RingSizeHalfModal)
